import React from 'react';

interface IntroductoryTextSectionProps {
  title: string;
  description: string;
}

export const IntroductoryTextSection: React.FC<IntroductoryTextSectionProps> = ({ title, description }) => {
  return (
    <section className="bg-white w-full">
      <div className="max-w-[1920px] mx-auto px-4 sm:px-8 md:px-12 lg:px-16 xl:px-24 2xl:px-32 py-8 sm:py-10 md:py-12">
        <div className="w-full text-[#212121] font-semibold">
          <h2 className="text-2xl sm:text-3xl md:text-[32px] mt-3 leading-[1.3] font-inter">
            {title}
          </h2>
          <p className="w-full text-lg sm:text-xl text-[rgba(33,33,33,1)] font-normal mt-3 leading-[1.3] font-inter">
            {description}
          </p>
        </div>
      </div>
    </section>
  );
}; 